(function ($) {
  'use strict';

  Drupal.behaviors.bigkaiserVideoGallery = {
    attach: function (context, settings) {
      $('.Field--name-field-video-playlist .Field-item a', context).swipebox();
    }
  };
}(jQuery));
